"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checklist = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Checkbox_1 = require("../../atoms/Checkbox");
var RadioButton_1 = require("../../atoms/RadioButton");
var styles_1 = require("./styles");
exports.Checklist = react_1.default.memo(function (_a) {
    var _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, options = _a.options;
    var classes = (0, styles_1.useStyles)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: options.map(function (group) { return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ mt: "20px" }, { children: (0, jsx_runtime_1.jsxs)(core_1.FormControl, __assign({ component: "fieldset" }, { children: [(0, jsx_runtime_1.jsx)(core_1.FormLabel, __assign({ component: "legend", className: classes.legend }, { children: group.legend })), (0, jsx_runtime_1.jsx)(core_1.FormGroup, __assign({ className: classes.group }, { children: group.options.map(function (option) {
                            return group.multiple ? ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "ChecklistGroupCheckbox__".concat(option.value), role: "menuitemcheckbox", checked: option.selected, onChange: function (event) { return onChange(event, { group: group, option: option }); }, label: option.label, value: option.value, name: option.label })) : ((0, jsx_runtime_1.jsx)(RadioButton_1.RadioButton, { id: "ChecklistGroupRadio__".concat(group.legend, "__").concat(option.label), role: "menuitemradio", checked: option.selected, onChange: function (event) { return onChange(event, { group: group, option: option }); }, label: option.label, value: option.value, name: group.legend }));
                        }) }))] })) }), group.legend)); }) }));
});
